import { ProjectsTreeCell } from './projectsTreeCell';
import { ProjectsTreeColumn } from './projectsTreeColumn';
import { ProjectsTreeLayout } from './projectsTreeLayout';
import { ProjectsTreeProjectCell } from './projectsTreeProjectCell';

export const ProjectTreeAlias = {
    Column: ProjectsTreeColumn,
    Layout: ProjectsTreeLayout,
    ProjectCell: ProjectsTreeProjectCell,
    Cell: ProjectsTreeCell,
};
